export default __webpack_public_path__ + "static/22-e7d93592fe157338e21fdbe82fc5658a.png";